import download from 'downloadjs';
import { CONTRACT_ACTION } from 'model/constants/actionConstants';
import { httpStatus, httpTextStatus } from 'model/constants/variableConstant';
import { getGeneralAccInfoList } from 'model/services/LoginService';

const startFetching = () => ({
  type: CONTRACT_ACTION.START_FETCHING,
});

const stopFetching = () => ({
  type: CONTRACT_ACTION.STOP_FETCHING,
});

const startFetchingBuyer = () => ({
  type: CONTRACT_ACTION.START_FETCHING_BUYER,
});

const stopFetchingBuyer = () => ({
  type: CONTRACT_ACTION.STOP_FETCHING_BUYER,
});

const startFetchingProduct = () => ({
  type: CONTRACT_ACTION.START_FETCHING_PRODUCT,
});

const stopFetchingProduct = () => ({
  type: CONTRACT_ACTION.STOP_FETCHING_PRODUCT,
});

const startFetchingFee = () => ({
  type: CONTRACT_ACTION.START_FETCHING_FEE,
});

const stopFetchingFee = () => ({
  type: CONTRACT_ACTION.STOP_FETCHING_FEE,
});

const startFetchingDocument = () => ({
  type: CONTRACT_ACTION.START_FETCHING_DOCUMENT,
});

const stopFetchingDocument = () => ({
  type: CONTRACT_ACTION.STOP_FETCHING_DOCUMENT,
});

const setContracts = (contracts) => ({
  type: CONTRACT_ACTION.SET_CONTRACTS,
  payload: contracts,
});

const setBuyer = (buyer) => ({
  type: CONTRACT_ACTION.SET_BUYER,
  payload: buyer,
});

const setProduct = (product) => ({
  type: CONTRACT_ACTION.SET_PRODUCT,
  payload: product,
});

const setFee = (fee) => ({
  type: CONTRACT_ACTION.SET_FEE,
  payload: fee,
});

const setDocument = (document) => ({
  type: CONTRACT_ACTION.SET_DOCUMENT,
  payload: document,
});

const setReportYear = (report) => ({
  type: CONTRACT_ACTION.SET_REPORT_YEAR,
  payload: report,
});

const setProposal = (proposal) => ({
  type: CONTRACT_ACTION.SET_PROPOSAL,
  payload: proposal,
});

const setCurrentContract = (contract) => ({
  type: CONTRACT_ACTION.SET_CURRENT_CONTRACT,
  payload: contract,
});

const reset = () => ({
  type: CONTRACT_ACTION.RESET,
});

const resetAContract = () => ({
  type: CONTRACT_ACTION.RESET_A_CONTRACT,
});

const setInvoice = (invoice) => ({
  type: CONTRACT_ACTION.SET_INVOICE,
  payload: invoice,
});

const getListContract =
  ({ userCode }) =>
  async (dispatch) => {
    dispatch(startFetching());
    try {
      const res = await getGeneralAccInfoList(userCode);

      const data = res?.data;
      if (data?.status === httpTextStatus.success) {
        const info = data?.data?.policyNumbers;
        dispatch(setContracts(info));
      }
      dispatch(stopFetching());
      return data;
    } catch (error) {
      console.log(error);
    }
  };

const setPopupLoyalty = (status) => ({
  type: CONTRACT_ACTION.SET_POPUP_LOYALTY,
  payload: status,
});

const ContractAction = {
  setContracts,
  setCurrentContract,
  setBuyer,
  setProduct,
  setFee,
  setDocument,
  getListContract,
  // getInfoBuyer,
  // getInfoProducts,
  // getInfoPaymentProcess,
  // getReport,
  resetAContract,
  setPopupLoyalty,
  // getProposal,
  // downloadReport,
  // downloadBill,
  // downloadProposal,
  // searchInvoice,
  // benefitResolve,
  // onViewPdf,
  reset,
};
export default ContractAction;
